import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BadgeCheck, Clock, Landmark } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const FIELDS = [
  ["club_name", "Club name", "e.g. St Brigid's GAA"], ["account_name", "Account holder name", "As it appears on the club bank account"],
  ["iban", "IBAN", "IE29 AIBK 9311 5212 3456 78"], ["bic", "BIC (optional)", "e.g. AIBKIE2D"],
  ["contact_name", "Club contact name", "Who we verify the details with"], ["contact_role", "Their role", "Treasurer, Chairperson or Secretary"],
  ["contact_email", "Contact email", "treasurer@club.ie"], ["contact_phone", "Contact phone", "087 123 4567"],
];
const STATUS = {
  pending: [Clock, "Awaiting verification – we'll contact your club before any transfer", "border-amber-400 bg-amber-50"],
  verified: [BadgeCheck, "Verified – funds will be paid to this account", "border-lime-500 bg-lime-50"],
  rejected: [Clock, "We couldn't verify these details – please check and save again", "border-red-500 bg-red-50"],
};
const input = "w-full border-2 border-slate-200 px-3 py-2 text-sm font-semibold outline-none focus:border-slate-900";

export const PayoutForm = () => {
  const [saved, setSaved] = useState(undefined);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/coach/payout").then((r) => { setSaved(r.data); if (r.data) setForm({ ...r.data, iban: "" }); }); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.put("/coach/payout", form); setSaved(data); setForm({ ...data, iban: "" }); toast.success("Club bank details saved – we'll verify them with your club contact"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const st = saved && STATUS[saved.status];
  const Icon = st?.[0];
  return (
    <section className="border-2 border-slate-900 bg-white p-5" data-testid="coach-payout">
      <h2 className="flex items-center gap-2 font-display text-lg font-extrabold uppercase"><Landmark className="h-5 w-5" /> Where should we send the funds?</h2>
      <p className="mt-1 text-sm text-slate-600">Funds are paid by bank transfer to the club's own account when the fundraiser closes. We verify these details with the club contact before paying.</p>
      {st && <div className={`mt-3 flex items-center gap-2 border-2 px-3 py-2 text-sm font-semibold ${st[2]}`} data-testid="coach-payout-status"><Icon className="h-4 w-4" /> {st[1]} · IBAN {saved.iban}</div>}
      <form onSubmit={submit} className="mt-4 grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, label, ph]) => (
          <label key={k} className="text-xs font-bold">{label}
            <input value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={k === "iban" && saved ? `Re-enter to change (current ${saved.iban})` : ph}
              required={k !== "bic" && !(k === "iban" && saved)} type={k === "contact_email" ? "email" : "text"} className={`${input} mt-1`} data-testid={`payout-${k}-input`} />
          </label>
        ))}
        <button type="submit" disabled={busy || saved === undefined} className="btn-blaze px-4 py-2.5 text-sm sm:col-span-2 sm:justify-self-start" data-testid="payout-save-button">{busy ? "Saving…" : saved ? "Update bank details" : "Save bank details"}</button>
      </form>
    </section>
  );
};
